module.exports = __webpack_public_path__ + "img/w-product.0d6215c0.svg";